import { render } from "./ModalAddUpdateStaffRole.vue?vue&type=template&id=112a14c4"
import script from "./ModalAddUpdateStaffRole.vue?vue&type=script&lang=js"
export * from "./ModalAddUpdateStaffRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__